import Button from "@ui-kit/form/Button/Button.web";
import Icon from "@ui-kit/icons/Icon.web";
import { useTranslation } from "@shared/utils/internationalization";
import { BackButtonProps } from "./BackButton.props";

const BackButton = ({ label, ...props }: BackButtonProps) => {
  const { t } = useTranslation("common");

  return (
    <Button
      {...props}
      variant="underline"
      width="fit-content"
      p="none"
      _hover={{
        backgroundColor: "transparent",
      }}
      _active={{
        backgroundColor: "transparent",
      }}
      leftIcon={<Icon.ChevronLeft boxSize="element.md" />}
    >
      {label ?? t("Back")}
    </Button>
  );
};

export default BackButton;
